import React, { useEffect, useState } from 'react';
import { CTAButton } from './CTAButton';
export function PricingCard() {
  // Simple countdown timer logic (1h 12m 16s)
  const [timeLeft, setTimeLeft] = useState({
    h: 1,
    m: 12,
    s: 16
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          h,
          m,
          s
        } = prev;
        if (s > 0) s--;else {
          s = 59;
          if (m > 0) m--;else {
            m = 59;
            if (h > 0) h--;else {
              h = 1;
              m = 12;
              s = 16; // Reset for demo purposes
            }
          }
        }
        return {
          h,
          m,
          s
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (val: number) => val.toString().padStart(2, '0');
  return <section id="pricing" className="py-8 sm:py-12 px-4 bg-brand-cream scroll-mt-10" data-id="element-123">
      <div className="max-w-xl mx-auto" data-id="element-124">
        <div className="text-center mb-6" data-id="element-125">
          <h2 className="text-2xl sm:text-3xl font-serif font-bold text-brand-text-main" data-id="element-126">
            Sonderangebot — Nur für begrenzte Zeit
          </h2>
        </div>

        <div className="bg-white border-2 border-brand-gold rounded-2xl p-5 sm:p-8 shadow-xl relative" data-id="element-127">
          <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-brand-gold text-white font-bold px-4 py-1 rounded-full text-xs uppercase tracking-wide whitespace-nowrap" data-id="element-128">
            🔥 Nur noch wenige Plätze
          </div>

          <div className="text-center mb-6 mt-2" data-id="element-129">
            <h3 className="text-lg sm:text-xl font-bold text-brand-text-main mb-1" data-id="element-130">
              METABOLIK PRO
            </h3>
            <p className="text-sm text-brand-text-muted" data-id="element-131">
              6 Bücher + 5 Bonus (Digital)
            </p>
          </div>

          <div className="space-y-3 mb-6 bg-brand-sage-light/50 p-4 rounded-xl" data-id="element-132">
            <div className="flex justify-between items-center text-sm" data-id="element-133">
              <span className="text-brand-text-muted" data-id="element-134">Gesamtwert</span>
              <span className="text-brand-text-muted line-through" data-id="element-135">282€</span>
            </div>
            <div className="flex justify-between items-center text-sm" data-id="element-136">
              <span className="text-brand-text-muted" data-id="element-137">Normaler Preis</span>
              <span className="text-brand-text-muted line-through" data-id="element-138">97€</span>
            </div>
            <div className="flex justify-between items-center border-t border-brand-sage/20 pt-3 mt-3" data-id="element-139">
              <span className="font-bold text-brand-text-main" data-id="element-140">
                Ihr Preis heute
              </span>
              <span className="text-3xl sm:text-4xl font-black text-brand-olive" data-id="element-141">
                19€
              </span>
            </div>
          </div>

          <div className="text-center mb-6" data-id="element-142">
            <div className="inline-flex flex-col items-center bg-red-50 text-red-600 px-6 py-2 rounded-lg" data-id="element-143">
              <div className="text-xl font-mono font-bold tracking-widest flex items-center gap-1" data-id="element-144">
                ⏱️ {formatTime(timeLeft.h)} : {formatTime(timeLeft.m)} :{' '}
                {formatTime(timeLeft.s)}
              </div>
              <div className="text-[10px] uppercase font-bold tracking-widest flex gap-4 mt-1 opacity-70" data-id="element-145">
                <span data-id="element-146">Std</span>
                <span data-id="element-147">Min</span>
                <span data-id="element-148">Sek</span>
              </div>
            </div>
          </div>

          <CTAButton href="https://500-rezepte.impultienda.ar/checkout" variant="premium" className="w-full text-sm sm:text-base" data-id="element-149">
            🌿 JA — ICH WILL MEINE 500 REZEPTE
          </CTAButton>

          <div className="text-center mt-4 space-y-2" data-id="element-150">
            <p className="text-xs text-brand-text-muted font-medium" data-id="element-151">
              Sofortiger Zugang — Lieferung per E-Mail
            </p>
            <div className="flex justify-center items-center gap-2 text-xs font-medium text-brand-text-main" data-id="element-152">
              <span className="text-brand-gold" data-id="element-153">⭐⭐⭐⭐⭐</span> 4.9/5
              <span className="text-brand-text-muted/30" data-id="element-154">|</span>
              <span data-id="element-155">🛡️ 30-Tage-Garantie</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}